export const navBarHighlightColor = "#1f2770";
export const dropdownHighlightColor = "white";
export const footerHighlightColor = "white";
